import { Box, Typography } from "@mui/material";
import React /*, { useState }*/ from "react";
import "../../output.css";
import LOGO from "../../assets/logo.png";
import { Link } from "react-router-dom";
const HeroText = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}>
      <Link
        to={"/"}
        style={{
          marginTop: "-130px",
          marginRight: "-150px",
        }}>
        <img
          style={{
            width: "250px",
            //  position: "absolute",
            //  marginBottom: "50px",
          }}
          src={LOGO}
          alt="Teksa Travel."
        />
      </Link>
      <Typography
        variant="h4"
        component={"h1"}
        sx={{
          fontWeight: "bold",
          marginTop: "-25px",
          marginBottom: "75px",
        }}>
        Book With Us Relax And Enjoy your Journey !
      </Typography>
    </Box>
  );
};

export default HeroText;
